import * as React from 'react'
// libs
import { reduxForm } from 'redux-form'
// view components
import PermissionOption from './PermissionOption'
// views
import { BusinessCenterIcon, Header, LockIcon, Wrapper } from './view'
// themes
import { CloseIcon } from 'components/UI/Icons'
// constants
import { Forms } from 'constants/forms'

interface Props {
  closePopup: () => void
  entityType: string
  visibility: 'Private' | 'Organisation'
  handleSetVisibility: (value: boolean) => void
}

export const VisibilitySettingsMenu: React.FC<Props> = ({
  entityType,
  visibility,
  closePopup,
  handleSetVisibility
}) => {
  const changeVisibility = (value: boolean) => () => {
    handleSetVisibility(value)
  }

  const visibilityModes = [
    {
      title: 'Private',
      description: `Only the ${entityType} owner, members and other users assigned group security privileges can access this ${entityType}.`,
      icon: (isActive: boolean) => <LockIcon isActive={isActive} />,
      onClick: changeVisibility(true)
    },
    {
      title: 'Organisation',
      description: `All members of organisation can see this ${entityType}.`,
      icon: (isActive: boolean) => <BusinessCenterIcon isActive={!isActive} />,
      onClick: changeVisibility(false)
    }
  ]

  return (
    <Wrapper>
      <Header>
        <span>Change Visibility</span>
        <CloseIcon right={0} onClick={closePopup} />
      </Header>

      {visibilityModes.map((mode) => (
        <PermissionOption
          key={mode.title}
          icon={mode.icon}
          title={mode.title}
          description={mode.description}
          handleSetPermission={mode.onClick}
          isActive={mode.title === visibility}
        />
      ))}
    </Wrapper>
  )
}

export default reduxForm<any, any>({ form: Forms.ENTITY_VISIBILITY_SETTINGS_FORM })(VisibilitySettingsMenu)
